<!-- Zone actions : bouton Report + icône paramètres -->
<ng-template #pageBarActionsTpl>
    <app-button label="Report" [addIconLeft]="true" state="disabled" data-attr="area-btn-report">
        <img slot="icon-left" src="./../../assets/icon/new_icon/report.svg" />
    </app-button>
    <app-button [addIconLeft]="true" variant="tertiary" state="disabled" data-attr="area-btn-settings">
        <img slot="icon-left" src="./../../assets/icon/new_icon/settings_black.svg" />
    </app-button>
</ng-template>

<ng-template #searchTpl>
    <div class="flex-row">
        <app-input placeholder="Search" [(ngModel)]="searchText" [clearable]="true" data-attr="area-input-search">
            <svg slot="icon-left" width="16" height="16">
                <use href="../../../assets/icon/new_icon/search.svg"></use>
            </svg>
        </app-input>
        
        <div class="filter-popup-wrapper" #filterBtn>
            <app-button
                [addIconLeft]="true"
                [addLabel]="false"
                size="small"
                variant="secondary"
                (click)="openFilter(filterBtn)"
                [state]="filterOpen() ? 'pressed' : 'default'"
                [class.no-hover]="filterOpen()"
                data-attr="area-btn-filter">
                <img slot="icon-left" src="./../../assets/icon/new_icon/filter.svg" />
                <img slot="icon-left-active" src="./../../assets/icon/new_icon/filter_active.svg" />
            </app-button>
            @if (filterOpen()) {
                <app-popup-panel
                    [isOpen]="true"
                    [showHeader]="false"
                    size="medium"
                    class="popup-panel-position"
                    [ngStyle]="{ top: filterPopupPos().top, right: filterPopupPos().right }"
                    (closed)="filterOpen.set(false)">

                    <!-- Level 1 dropdown -->
                    <!-- <div class="filter-panel">
                        <div class="filter-panel__field">
                            <span class="filter-panel__label">Level 1</span>
                            <app-select
                                [options]="level1Options"
                                [ngModel]="filterLevel1Value()?.id ?? null"
                                (selectionChange)="filterLevel1Value.set($event)"
                                placeholder="None"
                                data-attr="area-select-level1">
                            </app-select>
                        </div>
                    </div> -->

                    <!-- Blast name display : position des « ... » -->
                    <div class="filter-panel">
                        <div class="filter-panel__field">
                            <span class="filter-panel__label">{{ 'AREA.SITE_NAME_DISPLAY' | translate }}</span>
                            <app-select
                                [options]="blastDisplayOptions"
                                [ngModel]="blastDisplayValue()?.id ?? 'end'"
                                (selectionChange)="blastDisplayValue.set($event)"
                                placeholder="{{ 'AREA.TRUNCATED_AT_END' | translate }}">
                            </app-select>
                        </div>
                    </div>

                    <!-- Footer buttons -->
                    <ng-container slot="footer">
                        <div style="width: 85px;">
                            <app-button
                                variant="primary"
                                color="mint"
                                size="small"
                                [fullWidth]="true"
                                [label]="'GLOBAL.APPLY' | translate"
                                (clicked)="applyFilter()"
                                data-attr="area-btn-apply">
                            </app-button>
                        </div>

                        <app-button
                            [addIconLeft]="true"
                            [label]="'GLOBAL.RESET' | translate"
                            size="small"
                            variant="secondary"
                            color="mint"
                            (clicked)="resetFilter()"
                            data-attr="area-btn-reset">
                            <img slot="icon-left" src="./../../assets/icon/new_icon/restore.svg" />
                            <img slot="icon-left-active" src="./../../assets/icon/new_icon/restore_active.svg" />
                        </app-button>
                    </ng-container>

                </app-popup-panel>
            }
        </div>
    </div>
</ng-template>

<ng-template #actionsTpl></ng-template>

<!-- Contenu de la page -->
<div class="page-body">
    <app-sites-map 
        [hidden]="activeTab() !== 'maps'"
        [sites]="visibleSites()"
        [selectedRegionSiteIds]="selectedRegionSiteIds()"
        [selectedSiteId]="selectedSiteId()"
        [flyTo]="flyTo()"
        [closePopupTrigger]="closePopupTrigger()"
        (siteClicked)="onSiteClicked($event)"
        (markerSelected)="onMarkerSelected($event)"
        (popupClosed)="onPopupClosed()"
        class="full-map">
    </app-sites-map>

    @if (activeTab() === 'dashboard') {
      <app-area-dashboard [region]="selectedRegion()"></app-area-dashboard>
    }

</div>
